import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default { 
  // 获取巡更列表
  patrolList(data) {
    const params = data
    return request({
      url: urlParams + '/patrol/list',
      type: 'get',
      params: params
    })
  },  
  // 巡更列表 新增
  patrolAdd(data) {
    const params = data
    return request({
      url: urlParams + '/patrol/add',
      type: 'post',
      params: params,
      qs:false
    })
  },   
  // 巡更列表 修改
  patrolUp(data) {
    const params = data
    return request({
      url: urlParams + '/patrol/up',
      type: 'post',
      params: params,
      qs:false
    })
  },     
  // 删除
  patrolDel(data) {
    const params = data
    return request({
      url: urlParams + '/patrol/del',
      type: 'post',
      params: params
    })
  },   
  //生成二维码
  patrolGenerateQrCode(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-point/generateQrCode',
      type: 'post',
      params: params
    })
  },  
   //图片转换
   verificationBase64(data) {
    const params = data
    return request({
      url: urlParams + '/verification/imgToBase64',
      type: 'GET',
      params: params
    })
  }, 
  // 新巡更接口
    // 巡更标准列表
  patrolLevelList(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-level/list',
      type: 'get',
      params: params
    })
  }, 
    // 巡更标准总列表
  patrolLevelTotalList(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-level/totalList',
      type: 'get',
      params: params
    })
  },  
    // 巡更标准子列表
    patrolLevelsonList(data) {
      const params = data
      return request({
        url: urlParams + '/patrol-level/sonList',
        type: 'post',
        params: params
      })
    },   
    // 巡更标准添加修改
  patrolLeveladdUp(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-level/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // 巡更标准删除
  patrolLeveldel(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-level/del',
      type: 'post',
      params: params
    })
  },  
  // 获取巡更点列表
  patrolClassList(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-point/list',
      type: 'get',
      params: params
    })
  },  
  // 巡更点列表 修改
  patrolClassAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-point/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },    
  // 删除
  patrolClassDel(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-point/del',
      type: 'post',
      params: params
    })
  },    
  // 巡更路线列表
  patrolRouteList(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-route/list',
      type: 'get',
      params: params
    })
  },    
  // 巡更路线添加修改
  patrolRouteAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-route/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // 巡更标准删除
  patrolRoutedel(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-route/del',
      type: 'post',
      params: params
    })
  },   
  // 巡更计划列表
  patrolPlanList(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-plan/list',
      type: 'get',
      params: params
    })
  },    
  // 巡更计划添加修改
  patrolPlanAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-plan/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // 巡更计划删除
  patrolPlandel(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-plan/del',
      type: 'post',
      params: params
    })
  },    
  // 巡更任务列表
  patrolTaskList(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-task/list',
      type: 'get',
      params: params
    })
  },   
  // 巡更任务列表
  patrolTaskPointList(data) {
    const params = data
    return request({
      url: urlParams + '/patrol-task-point/list',
      type: 'get',
      params: params
    })
  },           
}